export const statisticsTranslation = {
  activity: 'Praca przy procesach',
  activityEmpty: 'Brak pracy przy procesach dla wybranych filtrów.',
  activityHint:
    'Ile różnych procesów każda osoba ruszyła w okresie: otworzyła, wysłała maila, zmieniła ofertę lub proces, dodała notatkę albo zadanie. Każdy proces liczy się osobie raz, bez względu na liczbę czynności.',
  activityKindsLegend: 'Rodzaje czynności — w ilu procesach się pojawiły.',
  activityLogSince:
    'Pełny ślad zmian istnieje od 21.09.2026 — wcześniej liczą się tylko otwarcia, maile i zadania.',
  activityOpened: 'Otwarte — procesy, które ta osoba utworzyła w okresie',
  activityOpenedCount: 'otwarte',
  activityOthers: 'Pozostałe — inne procesy, przy których coś zrobiła',
  activityOthersCount: 'pozostałe',
  all: 'Wszyscy',
  allSources: 'Wszystkie źródła',
  analysisPeriod: 'Okres analizy',
  byCreator: 'Według twórcy',
  byOwner: 'Według właściciela',
  calculationInfo:
    'Procesy utworzone w wybranym okresie. Wygrany — co najmniej jedna oferta sprzedana; przegrany — proces anulowany, zakończony bez sprzedaży lub ze wszystkimi ofertami anulowanymi. Negocjacje — oferta w ofertowaniu w kolejnej wersji. Kwoty netto: dla wygranych suma sprzedanych ofert, dla pozostałych najwyższa aktualna oferta.',
  close: 'Zamknij',
  companyOverview: 'Zespół w jednym spojrzeniu',
  comparisonHint:
    'Wspólna skala dla wszystkich osób. Kliknij sprzedawcę, aby zobaczyć jego wyniki.',
  conversion: 'Skuteczność sprzedaży',
  conversionHint:
    'Skuteczność sprzedaży = wygrane / wszystkie zamknięte procesy (wygrane i przegrane).',

  count: 'Nowe procesy',
  creator: 'Twórca procesu',
  customPeriod: 'Własny',
  empty: 'Brak procesów dla wybranych filtrów.',
  executiveOverview: 'Royal · Przegląd firmy',
  from: 'Od',
  heroSubtitle: 'Ludzie, zapytania i wyniki. Zobacz, co napędza Twoją firmę.',
  heroTitle: 'Pełny obraz sprzedaży.',
  inquiries: 'zapytań',
  invalidDates: 'Wybierz poprawny zakres dat: data „Od” nie może być późniejsza niż „Do”.',
  last30: 'Ostatnie 30 dni',
  last7: 'Ostatnie 7 dni',
  last90: 'Ostatnie 90 dni',
  loadError: 'Nie udało się pobrać statystyk. Spróbuj ponownie za chwilę.',
  loading: 'Wczytywanie statystyk',
  month: 'Miesięcznie',
  noAccess:
    'Brak dostępu do statystyk: Twoje konto nie ma uprawnienia do przeglądania raportów. Poproś administratora o jego nadanie.',
  noOwner: 'Bez właściciela',
  noPeople: 'Nie znaleziono osoby.',
  overviewHint: 'Porównanie wszystkich sprzedawców w wybranym zakresie filtrów.',
  owner: 'Właściciel procesu',
  peopleHint:
    'Wybierz jedną lub kilka osób. Zmiany są widoczne od razu. Pusty wybór oznacza cały zespół.',
  person: 'Pracownik',
  pipeline: 'Wartość otwartych',
  reset: 'Wyczyść filtry',
  revenue: 'Wartość wygranych',
  salesComparison: 'Wyniki sprzedawców',
  searchPerson: 'Szukaj osoby',
  selectedPeople: 'Wybrane osoby',
  short30: '30 dni',
  short7: '7 dni',
  short90: '90 dni',
  showResults: 'Pokaż wyniki',
  source: 'Źródło zapytania',
  sourceLabels: {
    active: 'Sprzedaż aktywna',
    facebook: 'Facebook / Instagram',
    form: 'Formularz',
    mailbox: 'Ogólna skrzynka',
    other: 'Inne',
    reactive: 'Sprzedaż reaktywna',
  },
  sources: 'Skąd przychodzą zapytania?',
  sourcesHint: 'Kliknij źródło, aby przefiltrować cały panel.',
  stageLabels: {
    lost: 'Przegrany',
    negotiation: 'Negocjacje',
    new: 'Nowe zapytanie',
    offer: 'Oferta wysłana',
    won: 'Wygrany',
  },
  stages: 'Status procesów',
  subtitle: 'Sprzedaż i praca zespołu w jednym miejscu.',
  team: 'Wyniki zespołu',
  teamRankingHint: 'Ranking według wartości wygranych · kliknij osobę, aby zobaczyć jej wyniki',
  teamShare: 'zapytań zespołu',
  title: 'Statystyki',
  to: 'Do',
  trend: 'Rytm zapytań',
  trendHint: 'Liczba procesów według daty utworzenia. Kliknij słupek, aby wybrać okres.',
  unknownCreator: 'Nieznany',
  unknownSource: 'Nie ustalono',
  week: 'Tygodniowo',
  wholeTeam: 'Cały zespół',
  workKinds: {
    email: 'maile',
    note: 'notatki',
    offer: 'oferty',
    process: 'zmiany w procesie',
    task: 'zadania',
  },
};
